import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { EndpointBuilder } from '@reduxjs/toolkit/query';
import { CompanyOwnerDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, CompanyOwnerDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.COMPANY_OWNERS,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'company-owners', id: 'GET' },
            { type: 'company-owners-with-join', id: 'GET-JOIN' },
        ],
    });
